"use strict"; // Start of use strict
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = js_swiper_url;
  s.async=true;
  if(is_home == 1){
    s.onload = function(){ init_carousel(); init_tabs()};
  }else{
      s.onload = function(){ init_carousel(); };
  }
  document.getElementsByTagName('head')[0].appendChild(s);

  function init_carousel(){
      var swiper = new Swiper(".mySwiper", {
        slidesPerView: 2,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });
    
      var swiper = new Swiper(".slide-Swiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        autoplay: {
          enabled: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next-slide",
          prevEl: ".swiper-button-prev-slide",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
               enabled: true,
            },
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                enabled: false,
              },
          },
        },
      });
      
    var swiper = new Swiper(".collection-slide-Swiper", {
        slidesPerView: 3,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
       autoplay: {
          delay: 3000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 15,
          },
        },
      });

    var swiper = new Swiper(".brand-slide-Swiper", {
        slidesPerView: 4,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
        loop: true,
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 15,
          },
        },
      });

      var swiper = new Swiper(".featured-blogs", {
        slidesPerView: 2,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next-2",
          prevEl: ".swiper-button-prev-2",
        },
       // autoplay: {
         // delay: 3000,
        //},
       // loop: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });

    var swiper = new Swiper(".video-gallery-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      });

      var swiper = new Swiper(".best-seller-swiper", {
        slidesPerView: 1,
        spaceBetween:0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next-1",
          prevEl: ".swiper-button-prev-1",
        },
        breakpoints: {
          640: {
            slidesPerView: 1.1,
            spaceBetween: 2,
          },
          768: {
            slidesPerView: 3.1,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4.1,
            spaceBetween: 16,
          },
        },
      });
  }

  function initNewsletters() {
      if (localStorage.getItem("popup-call") === null) {
        var count = 3; // set secconds
        var counter = setTimeout(function() {
          var element = document.getElementById("newsletterModal");
          element.classList.add("show");      
          element.classList.add("popupshow");  
           localStorage.setItem('popup-call', 1);
           closeModel();
        }, 1000 * count);
      }
  }

function closeModel(){
    const popup = document.getElementById('model-close')
    popup.addEventListener('click', (event) => {
      var element = document.getElementById("newsletterModal");
      element.classList.remove("show");      
      element.classList.remove("popupshow");
  }); 
}

function playVideo(){
  var counter = setTimeout(function() {
      let vid = document.getElementById("playvideo");
      if(vid) {
         vid.click();
        var w = window.innerWidth;
        if(w < 591){
          document.getElementById("deferred_media_video").style.ratiopercent = "56";
        }
         document.querySelector('video').setAttribute('oncontextmenu', "return false;");
      }
    }, 1000 * 5);
}

function init_tabs(){
  
  let tabs = document.getElementById("category-tabs").querySelectorAll('li');

    tabs.forEach((item, index) => {
      var returnId = item.getAttribute('data-id');
      var classTabs = "."+returnId+"-swiper";
      var pre = ".swiper-button-prev-"+returnId;
      var next = ".swiper-button-next-"+returnId;
       var swiper = new Swiper(classTabs, {
          slidesPerView:1,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: next,
            prevEl: pre,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 2,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView:4,
              spaceBetween: 10,
            },
            1320: {
              slidesPerView:5,
              spaceBetween: 10,
            },
          },
        });      
    });
}

document.addEventListener("DOMContentLoaded",function(){
  playVideo();
});
